
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contracts",
      function () {
        return require("private-next-pages/contracts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contracts"])
      });
    }
  